(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["new-price"] && !Shopify.designMode) return;
  try {
    /* Keeps the block in sync on themes that do not re-render it when the variant changes.
     If the theme re-renders/morphs the section, the server output is already correct. */
  (function () {
    'use strict';
    var controllers = new WeakMap();

    function fmt(cents, f) {
      return window.Shopify && typeof window.Shopify.formatMoney === 'function'
        ? window.Shopify.formatMoney(cents, f) : null;
    }

    function variantId(section) {
      var input = section.querySelector('form[action*="/cart/add"] [name="id"]');
      if (input && input.value) return String(input.value);
      var q = new URLSearchParams(window.location.search).get('variant');
      return q ? String(q) : null;
    }

    function update(root, section, data) {
      var id = variantId(section);
      var v = id && data.variants[id];
      if (!v) return;
      var price = Number(v.p), compare = Number(v.c), unit = Number(v.u);
      var hasMrp = isFinite(price) && isFinite(compare) && compare > 0 && compare > price;
      var pct = hasMrp ? Math.round(((compare - price) / compare) * 100) : 0;
      if (!isFinite(pct) || pct < 0) pct = 0;
      var now = fmt(price, data.format);
      if (now === null) return;

      var nowEl = root.querySelector('[data-pdp-now]');
      var label = nowEl.querySelector('.visually-hidden');
      nowEl.textContent = '';
      if (label) nowEl.appendChild(label);
      nowEl.appendChild(document.createTextNode(' ' + now));

      var mrp = root.querySelector('[data-pdp-mrp]');
      var save = root.querySelector('[data-pdp-save]');
      mrp.hidden = !hasMrp;
      save.hidden = !(hasMrp && pct > 0);
      if (hasMrp) root.querySelector('[data-pdp-mrp-value]').textContent = fmt(compare, data.format);
      if (pct > 0) root.querySelector('[data-pdp-save-value]').textContent = String(pct);

      var unitEl = root.querySelector('[data-pdp-unit]');
      var showUnit = isFinite(unit) && unit > 0 && v.ul;
      unitEl.hidden = !showUnit;
      if (showUnit) root.querySelector('[data-pdp-unit-value]').textContent = fmt(unit, data.format) + ' / ' + v.ul;
    }

    function init(root) {
      if (controllers.has(root)) return;
      var jsonEl = root.querySelector('[data-pdp-price-json]');
      if (!jsonEl) return;
      var data;
      try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
      var section = root.closest('[id^="shopify-section-"]') || document;

      var ac = new AbortController();
      controllers.set(root, ac);
      var pending = false;
      function schedule() {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; update(root, section, data); });
      }
      section.addEventListener('change', schedule, { signal: ac.signal });
      section.addEventListener('variant:change', schedule, { signal: ac.signal });
      section.addEventListener('variant:update', schedule, { signal: ac.signal });
      window.addEventListener('popstate', schedule, { signal: ac.signal });
      schedule();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-pdp-price]').forEach(init);
    }

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      e.target.querySelectorAll('[data-pdp-price]').forEach(function (r) {
        var ac = controllers.get(r);
        if (ac) { ac.abort(); controllers.delete(r); }
      });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
